import { render, staticRenderFns } from "./QRegistrationsDrilldown.vue?vue&type=template&id=5b1cea19&scoped=true&"
import script from "./QRegistrationsDrilldown.vue?vue&type=script&lang=js&"
export * from "./QRegistrationsDrilldown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1cea19",
  null
  
)

export default component.exports